import React from 'react';

import './shared/styles/crema.less';
import {
  AppContextProvider,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
} from './domain';
import {BrowserRouter} from 'react-router-dom';
import AuthContextProvider from './pages/auth/context';
import {QueryClient, QueryClientProvider} from 'react-query';
import DefaultKeyContextProvider from './pages/manage-shops/context/active-key';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <AppContextProvider>
      <AuthContextProvider>
        <QueryClientProvider client={queryClient}>
          <AppThemeProvider>
            <AppLocaleProvider>
              <BrowserRouter>
                <AuthRoutes>
                  <DefaultKeyContextProvider>
                    <AppLayout />
                  </DefaultKeyContextProvider>
                </AuthRoutes>
              </BrowserRouter>
            </AppLocaleProvider>
          </AppThemeProvider>
        </QueryClientProvider>
      </AuthContextProvider>
    </AppContextProvider>
  );
};

export default App;
